module.exports = __webpack_public_path__ + "static/img/matchLevelImg.f7e0e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matchLevelImg.jpg
// module id = JJ2U
// module chunks = 1